import { render, staticRenderFns } from "./WebInventory.vue?vue&type=template&id=2ba84d93&scoped=true&"
import script from "./WebInventory.vue?vue&type=script&lang=ts&"
export * from "./WebInventory.vue?vue&type=script&lang=ts&"
import style0 from "./WebInventory.vue?vue&type=style&index=0&id=2ba84d93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba84d93",
  null
  
)

export default component.exports